import React from 'react';
import './Certificate.css';
import apeedalogo from "../../component/images/optimized/apeedalogo.webp";
import fssailogo from "../../component/images/optimized/fssailogo.webp";
import ieclogo from "../../component/images/optimized/ieclogo.webp";
import organicindialogo from "../../component/images/optimized/organicindialogo.webp";
import isologo from "../../component/images/optimized/isologo.webp";
import haccplogo from "../../component/images/optimized/haccplogo.webp";
import globalgpalogo from "../../component/images/optimized/globalgpalogo.webp";
import fairtradelogo from "../../component/images/optimized/fairtradelogo.webp";


const certificates = [
  {
    src: apeedalogo,
    webpSrc: apeedalogo,
    title: 'Agricultural and Processed Food Products Export Development Authority',
    width: 120,
    height: 80,
  },
  {
    src: fssailogo,
    webpSrc: fssailogo,
    title: 'Food Safety and Standards Authority of India',
    width: 120,
    height: 80,
  },
  {
    src: ieclogo,
    webpSrc: ieclogo,
    title: 'Import Export Code (IEC)',
    width: 120,
    height: 80,
  },
  {
    src: organicindialogo,
    webpSrc: organicindialogo,
    title: 'India Organic Certification (Under Process)',
    width: 120,
    height: 80,
  },
  {
    src: isologo,
    webpSrc: isologo,
    title: 'ISO Certification (Under Process)',
    width: 120,
    height: 80,
  },
  {
    src: haccplogo,
    webpSrc: haccplogo,
    title: 'HACCP - Hazard Analysis Critical Control Point (Under Process)',
    width: 120,
    height: 80,
  },
  {
    src: globalgpalogo,
    webpSrc: globalgpalogo,
    title: 'Good Agricultural Practices (Under Process)',
    width: 120,
    height: 80,
  },
  {
    src: fairtradelogo,
    webpSrc: fairtradelogo,
    title: 'Fair trade (Under Process)',
    width: 120,
    height: 80,
  },
];

const Certificate = () => {
  return (
    <section className="certifications" id="certifications" aria-labelledby="certifications-heading">
      <div className="container">
        <header className="section-header">
          <h2 id="certifications-heading" className="section-title">Our Certifications</h2>
          <p className="section-subtitle">Recognized by national and international Government regulatory bodies.</p>
        </header>

        <div className="certifications-grid">
          {certificates.map((cert, index) => (
            <div
              key={index}
              className="certification-card"
              itemScope
              itemType="https://schema.org/ImageObject"
            >
              <div className="certification-media">
                <picture>
                  <source srcSet={cert.webpSrc} type="image/webp" />
                  <img
                    src={cert.src}
                    alt={cert.alt}
                    className="certification-logo"
                    loading="lazy"
                    width={cert.width}
                    height={cert.height}
                    decoding="async"
                    itemProp="contentUrl"
                  />
                </picture>
              </div>
              <h3 className="certification-title" itemProp="name">{cert.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certificate;